import { useEffect, useRef, useState } from 'react'
import "./style.css"
import { ButtonGroup, Card, Col, Container,  Dropdown,  DropdownButton,  Form,  Nav, Navbar, Row, Stack } from 'react-bootstrap'
import { useQuery } from 'react-query';
import { Line } from 'react-chartjs-2';
import { Link, useParams } from 'react-router-dom'
import { useAgentContext } from '../../context/agent';
import { getMarktingData } from '../../api/agent';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import { 
	Chart as ChartJS, 
	CategoryScale, 
	LinearScale, 
	PointElement, 
	LineElement, 
	Title, 
	Tooltip, 
	Legend, 
	Filler,
	ArcElement
} from 'chart.js';
import PublishAgent from '../Deploy/PublishAgent';
import PieChartComponent from './PieChartComponent';
import SpinnerFullScreen from '../Other/SpinnerFullScreen';
ChartJS.register(
	CategoryScale, 
	LinearScale, 
	PointElement, 
	LineElement, 
	ArcElement,
	Title, 
	Tooltip, 
	Legend,
	Filler
);

function Marketing() {
	// const [totalMessages, setTotalMessages] = useState(0);
	// const [sessionsCount, setSessionsCount] = useState(0);
	// const [sessionIds, setSessionIds] = useState(new Set<string>());
	const [chartData, setChartData] = useState<any>(null);
	const [pieChatData, setPieChatData] = useState<any>(null);

	// default date range is last 7 days
	const [dateRange, setDateRange] = useState(() => {
		const toDate = new Date();
		const fromDate = new Date();
		fromDate.setDate(fromDate.getDate() - 7);
		return {fromDate, toDate}
	})
	// const chartRef = useRef<ChartJS>(null);
	const chartRef = useRef<ChartJS<'line'> | null>(null);
	const containerRef = useRef<HTMLDivElement | null>(null);
	
	const {agentId} = useParams();
	const {getAgentById} = useAgentContext();
	const agent = getAgentById(agentId || "");

	const {data, isLoading} = useQuery({
		queryKey: [
			'Marketing',
			agent?.accessKey,
			dateRange.fromDate.toISOString(),
			dateRange.toDate.toISOString(),
		],
		queryFn: () =>
			getMarktingData({
			orgId: agent?.organizationId!,
			agentId: agent?.id!,
			dateRange,
			}),
		enabled: !!agent?.id && !!agent?.organizationId,
	});

	// console.log("Marketing Data", data)


	const handleSelection = (option: string) => {
		const now = new Date();
		let fromDate, toDate;
	
		switch (option) {
			case '7days':
				fromDate = new Date();
				fromDate.setDate(now.getDate() - 7);
				toDate = now;
				break;
			case '30days':
				fromDate = new Date();
				fromDate.setDate(now.getDate() - 30);
				toDate = now;
				break;
			case '60days':
				fromDate = new Date();
				fromDate.setDate(now.getDate() - 60);
				toDate = now;
				break;
			case '90days':
				fromDate = new Date();
				fromDate.setDate(now.getDate() - 90);
				toDate = now;
				break;
			case 'lastCalendarWeek':
					const lastWeek = new Date(now);
					const dayOfWeek = now.getDay();
					const daysSinceSunday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
					lastWeek.setDate(now.getDate() - daysSinceSunday - 7); // Last week's Monday
					fromDate = lastWeek;
					toDate = new Date(lastWeek);
					toDate.setDate(toDate.getDate() + 6); // Last week's Sunday
					break;
			case 'lastCalendarMonth':
				fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1); // 1st of the previous month
				toDate = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of the previous month
				break;
			case 'thisYear':
				fromDate = new Date(now.getFullYear(), 0, 1); // January 1st of this year
				toDate = now;
				break;
			case 'last12months':
				fromDate = new Date();
				fromDate.setFullYear(now.getFullYear() - 1);
				toDate = now;
				break;
			case 'lastCalendarYear':
				fromDate = new Date(now.getFullYear() - 1, 0, 1); // January 1st of last year
				toDate = new Date(now.getFullYear() - 1, 11, 31); // December 31st of last year
				break;
			default:
				return;
		}

		setDateRange({fromDate, toDate})
	};
	const exportAsImage = () => {
		const container = containerRef.current;
		if (container) {
		  html2canvas(container, { scale: 2 }).then((canvas) => {
			const base64Image = canvas.toDataURL('image/png');
			const link = document.createElement('a');
			link.href = base64Image;
			link.download = 'chart_with_data.png';
			link.click();
		  });
		}
	  };
	
	  const exportAsPDF = () => {
		const container = containerRef.current;
		if (container) {
		  html2canvas(container, { scale: 2 }).then((canvas) => {
			const base64Image = canvas.toDataURL('image/png');
			const pdf = new jsPDF('landscape');
			pdf.addImage(base64Image, 'PNG', 10, 10, 280, 150);
			pdf.save('chart_with_data.pdf');
		  });
		}
	  };

	useEffect(() => {
		// Group messages by date and count them
		if (data) {

			// count total chat messages
			// setTotalMessages(messages.length);

			// count unique sessions
			// let uniqueSessionIds = ;
			// setSessionsCount(uniqueSessionIds.size);

			// extract graph data
			const messageCountByDate: { [date: string]: number } = {};
			data.messages.forEach((message) => {
				const date = new Date(message.createdAt).toLocaleDateString();
				if (messageCountByDate[date]) {
					messageCountByDate[date]++;
				} else {
					messageCountByDate[date] = 1;
				}
			});
		
			// Prepare data for the chart
			const labels = Object.keys(messageCountByDate); // Array of dates;
			const messageCounts = Object.values(messageCountByDate); // Array of message counts
			// console.log("Label", labels)
			// console.log("Data", messageCounts)
		
			setChartData({
				labels: labels,
				datasets: [
					{
					label: 'Number of Chat Messages',
					data: messageCounts,
					borderColor: 'rgba(75, 192, 192, 1)',
					backgroundColor: 'rgba(75, 192, 192, 0.2)',
					fill: true,
					tension: 0.1, // Optional: smooth out line
					}
				]
			});

			// Prepare data for the pie chart based on conversations type (web or whatsapp)
			const conversationCounts: { [key: string]: number } = {};
			data.conversations.forEach((conversation) => {
				const type = conversation.type;
				if (conversationCounts[type]) {
					conversationCounts[type]++;
				} else {
					conversationCounts[type] = 1;
				}
			}
			);
			const pieLabels = Object.keys(conversationCounts);
			const pieData = Object.values(conversationCounts);
			setPieChatData({
				labels: pieLabels,
				datasets: [
					{
						label: 'Conversations by Type',
						data: pieData,
						backgroundColor: [
							'rgb(255, 99, 132)',
							'rgb(54, 162, 235)',
							// 'rgb(255, 205, 86)'
						],
						hoverOffset: 4
					}
				]
			});
		}
	}, [data]);

  return (
	<>{agent && ( <>{!agent.isPublished ? <PublishAgent agent={agent}/> :
    <Container>
		<Navbar data-bs-theme="dark">
			<Container>
				<Navbar.Brand as={Link} to="./">
					Marketing
				</Navbar.Brand>
				<Nav className="me-auto">
					{/* <Nav.Link as={Link} to={`./`}>Web Chatbot</Nav.Link>
					<Nav.Link as={Link} to={`./`}>WhatsApp</Nav.Link>
					<Nav.Link as={Link} to={`./`}>Others</Nav.Link> */}
				</Nav>
			</Container>
		</Navbar>

		<Stack className='marketing light-theme'>
			{isLoading && <SpinnerFullScreen/>}
			<div className='graphArea' ref={containerRef}>
			<Row className='text-dark marketing-stats'>
				{/* create 3 columns */}
				<Col xs={12} md={4}>
					<h5>Sessions</h5>
					<h2>{data?.conversations.length || 0}</h2>
				</Col>
				<Col xs={12} md={4}>
						<h5>Messages</h5>
						<h2>{data?.messages?.length || 0}</h2>
				</Col>
				<Col xs={12} md={4}>
					<Form.Group controlId="dateRangeSelector" className='date-selector'>
						{/* <Form.Label>Select Date Range:</Form.Label> */}
						<Form.Select onChange={(e) => handleSelection(e.target.value)} defaultValue="" size='sm'>
							<option value="7days">Last 7 Days</option>
							<option value="30days">Last 30 Days</option>
							<option value="60days">Last 60 Days</option>
							<option value="90days">Last 90 Days</option>
							<option value="lastCalendarWeek">Last Week (Monday - Sunday)</option>
							<option value="lastCalendarMonth">Last Month</option>
							<option value="thisYear">This Year (Jan - Current)</option>
							<option value="last12months">Last 12 Months</option>
							<option value="lastCalendarYear">Last Year (Jan - Dec)</option>
						</Form.Select>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				{chartData && (
					<Line 
						ref={chartRef}
						data={chartData}
						options={{
							responsive: true,
							maintainAspectRatio: false,
							scales: {
								x: {
									title: { display: true, text: 'Date' }
								},
								y: {
									title: { display: true, text: 'Number of Messages' },
									beginAtZero: true
								}
							}
						}}/>
				)}
			</Row>
			</div>
			<Row style={{padding:'2em'}}>
				<Col xs={12} md={6}>
				<DropdownButton
					as={ButtonGroup}
					variant='outline-dark'
					title="Export Graph As">
					<Dropdown.Item eventKey="1" onClick={exportAsImage}>Image</Dropdown.Item>
					<Dropdown.Item eventKey="2" onClick={exportAsPDF}>PDF</Dropdown.Item>
				</DropdownButton>
				</Col>
			</Row>
		</Stack>
			
		<Row className='pie-chart align-items-stretch'>
			<Col className="d-flex" style={{ minHeight: '100%' }}>
				{/* <div className="flex-grow-1 d-flex align-items-stretch"> */}
					{pieChatData && <PieChartComponent pieData={pieChatData} />}
				{/* </div> */}
			</Col>
			<Col className="d-flex" style={{ minHeight: '100%' }}>
				<Card className='m-4 p-3 flex-grow-1 d-flex flex-column'>
					<Card.Title>Impressions on {dateRange.fromDate.toLocaleDateString()} to {dateRange.toDate.toLocaleDateString()}</Card.Title>
					<Card.Text>
						<div style={{ lineHeight: 2 }}>
							<strong>Total Sessions:</strong> {data?.conversations.length || 0} <br />
							<strong>Total Messages:</strong> {data?.messages?.length || 0} <br />
							<strong>Web Sessions:</strong> {data?.conversations.filter(c => c.type === 'web').length || 0} <br />
							<strong>WhatsApp Sessions:</strong> {data?.conversations.filter(c => c.type === 'whatsapp').length || 0} <br />
							<strong>Other Sessions:</strong> {data?.conversations.filter(c => c.type !== 'web' && c.type !== 'whatsapp').length || 0} <br />
							<strong>Total Users:</strong> {data?.conversations.length || 0} <br />
						</div>
					</Card.Text>
				</Card>
			</Col>
		</Row>
	</Container>
	}</>)}</>
  )
}

export default Marketing